// Same presets and radii as fAInance src/core.tsx BUTTON_STYLES.
export const BUTTON_CORNERS = [
  {id:"rounded",radius:20,key:"settings.cornersRounded"},
  {id:"soft",radius:10,key:"settings.cornersSoft"},
  {id:"square",radius:6,key:"settings.cornersSquare"},
  {id:"sharp",radius:2,key:"settings.cornersSharp"}
] as const;
export function buttonCornerRadius(raw: string | undefined): number {
  const named=BUTTON_CORNERS.find(item=>item.id===raw);if(named)return named.radius;
  const value=Number(raw);if(!raw||!Number.isFinite(value))return 20;
  return [...BUTTON_CORNERS].sort((a,b)=>Math.abs(a.radius-value)-Math.abs(b.radius-value))[0].radius;
}
